import React from "react";
import { NavLink } from "react-router-dom";
import { Mic, Inbox, CalendarRange, User as UserIcon } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import Logo from "./Logo";

const items = [
  { to: "/", label: "Capture", icon: Mic, testid: "nav-capture", end: true },
  { to: "/inbox", label: "Inbox", icon: Inbox, testid: "nav-inbox" },
  { to: "/ahead", label: "Ahead", icon: CalendarRange, testid: "nav-ahead" },
  { to: "/account", label: "You", icon: UserIcon, testid: "nav-settings" },
];

export default function Sidebar() {
  const { user } = useAuth();
  const initial = (user?.name || "?").charAt(0).toUpperCase();

  return (
    <aside
      className="hidden md:flex md:flex-col bg-[var(--surface2)] border-r border-[var(--line)] md:w-[260px] sticky top-0 z-30 md:h-screen md:self-start shrink-0"
      data-testid="sidebar"
    >
      <div className="px-6 py-7 flex flex-col gap-1.5 border-b border-[var(--line)] w-full" data-testid="sidebar-logo">
        <NavLink to="/" end data-testid="sidebar-logo-link" aria-label="Go to Capture">
          <Logo size={26} />
        </NavLink>
        <p className="hidden md:block text-xs text-[var(--ink3)] pl-[36px] -mt-0.5">Say it once.</p>
      </div>

      <nav className="flex flex-col gap-1 p-4 w-full">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-all duration-200 ${
                isActive
                  ? "bg-[var(--surface)] text-[var(--ink)] shadow-[0_2px_8px_rgba(0,0,0,0.05)]"
                  : "text-[var(--ink2)] hover:bg-[var(--surface)]"
              }`
            }
          >
            <Icon size={18} strokeWidth={1.75} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="hidden md:block mt-auto p-4 w-full border-t border-[var(--line)]">
        <NavLink
          to="/account"
          data-testid="sidebar-account-link"
          className="flex items-center gap-3 rounded-xl px-2 py-2 hover:bg-[var(--surface)] focus:bg-[var(--surface)] focus:outline-none transition-colors duration-200"
        >
          <div className="h-9 w-9 rounded-full bg-[var(--pine)] text-[var(--on-pine)] flex items-center justify-center text-sm font-semibold shrink-0">
            {initial}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[var(--ink)] truncate">{user?.name}</p>
            <p className="text-xs text-[var(--ink4)] truncate">
              {user?.partner ? `with ${user.partner.name}` : "Account"}
            </p>
          </div>
        </NavLink>
      </div>
    </aside>
  );
}
